module.exports = __webpack_public_path__ + "img/decor-signs-2.caa6e01d.svg";